import { createReducer } from '@reduxjs/toolkit';
import { setDebtAccount, amountChange } from 'actionCreators/debtConsolidation';

const debtConsolidationReducer = createReducer({ debtAccountList: [] }, (builder) => {
  builder.addCase(setDebtAccount, (state, action) => {
    let debtAccounts = [...state.debtAccountList];
    const { accountId, checked } = action.payload;
    if (!checked) {
      debtAccounts = debtAccounts.filter((account) => account !== accountId);
    } else {
      debtAccounts.push(accountId);
    }

    state.debtAccountList = debtAccounts;
  });

  builder.addCase(amountChange, (state, action) => {
    let debtAccounts = [...state.debtAccountList];
    const { accountId, type, value } = action.payload;

    debtAccounts.push({
      accountId,
      type,
      value
    });

    state.debtAccountList = debtAccounts;
  });
});

export { debtConsolidationReducer };
